import { CheckExistOtpResponse } from '@porterin/booking-flow/src/auth/domain/api-models/CheckExistOtpApiModel';
import { CustomerStatus } from '@porterin/booking-flow/src/auth/domain/entities/CustomerStatus';

const toCustomerStatusEntity = (
  apiModel: CheckExistOtpResponse,
): CustomerStatus => {
  return {
    status: apiModel.exists,
  };
};

export { toCustomerStatusEntity };
